import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "docs-theme";
const MOBILE_BREAKPOINT = 768;

export default class extends Controller {
  static targets = ["toggle", "logoLight", "logoDark"];

  connect() {
    this._applyForViewport();

    this._mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    this._boundMqChange = () => this._applyForViewport();
    this._mq.addEventListener("change", this._boundMqChange);
  }

  disconnect() {
    this._mq?.removeEventListener("change", this._boundMqChange);
  }

  toggle() {
    const isDark = document.documentElement.classList.contains("dark");
    this.apply(!isDark);
  }

  apply(dark) {
    if (dark) {
      document.documentElement.classList.add("dark");
      localStorage.setItem(STORAGE_KEY, "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem(STORAGE_KEY, "light");
    }
  }

  _isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  _applyForViewport() {
    if (this._isMobile()) {
      // Mobile is always dark — don't touch stored preference
      document.documentElement.classList.add("dark");
      return;
    }

    const saved = localStorage.getItem(STORAGE_KEY);
    // Default is dark; only go light if the user has explicitly chosen light
    const dark = saved !== "light";
    this.apply(dark);
  }
}
